import axios from "axios";

// const API_BASE_URL = "https://backendaiscworld-hbevgne7faaggqbr.eastus2-01.azurewebsites.net";
const apiurl=process.env.REACT_APP_API_Base_Url;
export const fetchTableMetadata = async (tableName: string) => {
  const response = await axios.get(`${apiurl}FileAction/DownloadSelectedFile`, {
    params: { TableName: tableName },
  });

  return response.data;
};

export const fetchFilteredTables = async () => {
  const response = await fetch(
    `${apiurl}FileAction/getTableList`
  );

  if (!response.ok) {
    throw new Error("Failed to fetch table list");
  }

  const result = await response.json();
  return result;
};